// extracted by mini-css-extract-plugin
export default {"footerBg":"S-z","footerTopLinks":"T-z","footerFeedback":"U-z","footerSocial":"V-z","footerLegalLinks":"W-z","footerIconCards":"X-z","footerBotCopy":"Y-z"};